export default __webpack_public_path__ + "static/media/3.22ac2c85.png";